import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { authApi } from '@/api/auth'
import { Loader2 } from 'lucide-react'
import { useMinCopy } from '@/i18n/useUiLocale'
import { useAuthStore } from '@/store/authStore'

export function GoogleCallbackPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const setAuth = useAuthStore((state) => state.setAuth)
  const t = useMinCopy({ preferGuest: true }).auth

  useEffect(() => {
    if (searchParams.get('ok') !== '1') {
      navigate('/login?error=google_auth_failed', { replace: true })
      return
    }

    const returnUrl = searchParams.get('returnUrl') || '/dashboard'

    async function completeSignIn() {
      try {
        const loginResponse = await authApi.refresh()
        const profileResponse = await authApi.getProfile(loginResponse.data.accessToken)
        setAuth(loginResponse.data.accessToken, profileResponse.data)
        navigate(returnUrl, { replace: true })
      } catch {
        navigate('/login?error=google_auth_failed', { replace: true })
      }
    }

    void completeSignIn()
  }, [navigate, searchParams, setAuth])

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4">
      <div className="flex items-center gap-3 rounded-md border border-slate-200 bg-white px-4 py-3 text-sm text-slate-700 shadow-sm">
        <Loader2 className="h-4 w-4 animate-spin text-primary" />
        {t.signingInWithGoogle}
      </div>
    </div>
  )
}
